import { Component, OnInit, ViewEncapsulation, Inject, Directive  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AlertTypeEnum } from '../../../alert/alert-type.enum';
import { MatButtonModule } from '@angular/material/button';


@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatDialogModule, MatButtonModule]
})
export class InfoDialogComponent implements OnInit {

  alertTypeEnum = AlertTypeEnum;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, type: AlertTypeEnum }) { }

  ngOnInit() {
  }

}
